import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../environments/environment';

const TOOLTIPS = {
    'asphalt-trucks-time':
        'De vrachtwagens worden gereserveerd tot de volgende bestelling. Als twee bestellingen op hetzelfde tijdstip zijn, wordt de som van de vrachtwagens gereserveerd.',
    asphaltcode: 'De code kan worden aangepast door een excel te uploaden via Instellingen => Asfalt',
    'asphalttype-nomill': 'Selecteer eerst een asfaltmolen',
    asphalttype: 'Alleen asfaltsoorten die geleverd worden door de gekozen molen worden weergegeven',
    'cutter-na-here': 'Je hebt deze frees al ingepland',
    'cutter-na-na': 'Deze frees is niet beschikbaar',
    'cutter-time-disabled': 'Kies eerst een frees',
    'cutter-time': 'Een frees mag de dag voor de ploeg ingezet worden, maar niet na de ploeg',
    'cutter-tons':
        'Het aantal ton gefreesd asfalt wordt in het diagram onderin het overzichtsscherm getoond als lichtblauwe staaf.',
    'entitytype-asfaltTeam':
        'De planning van een ploeg wordt i.t.t. een frees niet op tijd weergegeven, omdat een ploeg maximaal 12 uur per dag kan worden ingezet.',
    tons: 'Deze rij toont het totaal aantal aanvoer tonnen. De kleuren geven aan, tot 500 grijs, 500 tot 800 groen, 800 tot 1000 oranje, 1000+ rood',
    'trucks-count':
        'Het cijfer rechtsbovenin geeft het aantal beschikbare vrachtwagens weer. Vrachtwagens in dit veld worden niet meegerekend.',
    trucks: 'Deze rij geeft het aantal beschikbare vrachtwagens aan per dagdeel. Het minst tegelijk beschikbare aantal gedurende het dagdeel wordt getoond.',
    'wipetrucktime-na': 'Kies eerst een veeg/zuigwagen',
} as const;

@Pipe({ name: 'tt', standalone: false })
export class TooltipPipe implements PipeTransform {
    transform(value: any): any {
        const tooltip = TOOLTIPS[value];

        if (tooltip !== undefined) {
            return tooltip;
        }

        if (environment.production === false) {
            console.warn('No tooltip configured for ' + value);
        }
    }
}
